export default "__VITE_ASSET__DMs8dUoD__"